const BASE_URL = 'https://authenticulture.net';

export type DeepLink =
  | { type: 'post'; id: string }
  | { type: 'video'; hash: string };

export function buildPostLink(postId: string): string {
  return `${BASE_URL}/#post:${postId}`;
}

export function buildVideoLink(videoHash: string): string {
  return `${BASE_URL}/#video:${videoHash}`;
}

export function parseDeepLink(): DeepLink | null {
  const hash = window.location.hash;
  if (hash.startsWith('#post:')) return { type: 'post', id: hash.slice('#post:'.length) };
  if (hash.startsWith('#video:')) return { type: 'video', hash: hash.slice('#video:'.length) };
  return null;
}

export function clearDeepLink(): void {
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
